import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import api from "../api/axios";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

export default function AdminLogin() {
  const [form, setForm] = useState({ email:"", password:"" });
  const [err, setErr]   = useState("");
  const [unverified, setUnverified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resendDone, setResendDone] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const { adminLogin } = useAuth();
  const nav = useNavigate();

  const handleResend = async () => {
    if (!form.email) { setErr("Enter your admin email above first."); return; }
    setResendLoading(true);
    try {
      await api.post("/auth/resend-verification", { email: form.email });
      setResendDone(true);
    } catch {
      setErr("Failed to resend. Try again.");
    }
    setResendLoading(false);
  };

  const inp = {
    width:"100%", marginTop:6, padding:"12px 14px", borderRadius:10,
    border:"1px solid #1e293b", background:"#0d0d0d", color:"#f1f5f9",
    fontSize:14, outline:"none", boxSizing:"border-box"
  };

  const submit = async e => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      if (data.user.role !== "admin") {
        setErr("This login is for admins only.");
        setLoading(false);
        return;
      }
      adminLogin(data.token, data.user);
      nav("/admin");
    } catch (e) {
      if (e.response?.data?.email_unverified) setUnverified(true);
      setErr(e.response?.data?.message || "Login failed. Check your credentials.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0a", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <Helmet><meta name="robots" content="noindex, nofollow" /></Helmet>

      {/* Back button */}
      <div style={{ width:"100%", maxWidth:400, marginBottom:16 }}>
        <button
          onClick={() => nav(-1)}
          style={{ background:"transparent", border:"1px solid #1e293b", color:"#64748b", padding:"7px 16px", borderRadius:20, fontSize:13, cursor:"pointer", display:"inline-flex", alignItems:"center", gap:6 }}
        >
          ← Back
        </button>
      </div>

      <div style={{ background:"#111111", borderRadius:16, border:"1px solid #1e293b", padding:"36px 28px", width:"100%", maxWidth:400 }}>

        <div style={{ textAlign:"center", marginBottom:28 }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:8 }}>
            <Logo size={28} />
          </div>
          <div style={{ fontSize:16, fontWeight:700, color:"#f1f5f9", marginBottom:4 }}>Admin Login</div>
          <div style={{ fontSize:13, color:"#475569" }}>PadhaiPass Control Panel</div>
        </div>

        <div style={{ background:"#f9731610", border:"1px solid #f9731630", borderRadius:8, padding:"10px 14px", marginBottom:20, fontSize:12, color:"#f97316" }}>
          ⚠️ This page is for platform administrators only.
        </div>

        <form onSubmit={submit}>
          <div style={{ marginBottom:14 }}>
            <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Admin Email</label>
            <input
              required
              type="email"
              style={inp}
              value={form.email}
              onChange={e => setForm(f => ({ ...f, email:e.target.value }))}
              placeholder="admin@padhaipass.com"
            />
          </div>

          <div style={{ marginBottom:20 }}>
            <label style={{ fontSize:13, color:"#64748b", fontWeight:500 }}>Password</label>
            <input
              required
              type="password"
              style={inp}
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password:e.target.value }))}
              placeholder="••••••••"
            />
          </div>

          {err && (
            <div style={{ color:"#ef4444", fontSize:13, marginBottom:14, background:"#ef444415", padding:"10px 14px", borderRadius:8, border:"1px solid #ef444430" }}>
              {err}
              {unverified && (
                <div style={{ marginTop:8 }}>
                  {resendDone
                    ? <span style={{ color:"#22c55e" }}>Verification email sent! Check your inbox.</span>
                    : <button type="button" onClick={handleResend} disabled={resendLoading}
                        style={{ background:"none", border:"none", color:"#f97316", cursor:"pointer", fontSize:13, padding:0, textDecoration:"underline" }}>
                        {resendLoading ? "Sending..." : "Resend verification email"}
                      </button>
                  }
                </div>
              )}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{ width:"100%", padding:13, background:"#f97316", color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:"pointer" }}
          >
            {loading ? "Logging in..." : "Login to Admin Panel →"}
          </button>
        </form>

        <div style={{ marginTop:20, textAlign:"center" }}>
          <Link to="/admin-register" style={{ fontSize:13, color:"#475569", textDecoration:"none" }}>
            First time? Setup admin account →
          </Link>
        </div>
      </div>
    </div>
  );
}